import { Firestore } from '@angular/fire/firestore';
import { Injectable } from '@angular/core';
import { JobTitle } from '@models';

import { BaseService } from '../base/base.service';

import { ToastService } from './toast.service';

@Injectable({
  providedIn: 'root',
})
export class JobTitleService extends BaseService<JobTitle> {
  protected readonly documentPath = 'jobTitles';

  constructor(
    protected db: Firestore,
    protected toastService: ToastService
  ) {
    super(db, toastService);
  }
}
